const IMAGE_TOKEN_RE = /!\[[^\]]*\]\(([^)]*)\)/g;

type MarkdownImageAttachment = {
  url?: string;
  rawUrl?: string;
  thumbnailUrl?: string;
};

const attachmentUrls = (attachment: MarkdownImageAttachment): string[] => [
  ...new Set(
    [attachment.url, attachment.rawUrl, attachment.thumbnailUrl].filter(
      (item): item is string => Boolean(item),
    ),
  ),
];

const destUrls = (dest: string): string[] => {
  const trimmed = dest.trim();
  const titled = /^(.*?)\s+"([^"]*)"\s*$/.exec(trimmed);
  if (titled) {
    return [titled[1].trim(), titled[2]];
  }
  return [trimmed];
};

const urlsMatch = (destUrl: string, candidate: string): boolean =>
  destUrl === candidate ||
  destUrl.endsWith(candidate) ||
  candidate.endsWith(destUrl);

export function stripMarkdown(src: string): string {
  return src
    .replace(/!\[[^\]]*\]\([^\)]+\)/g, '')
    .replace(/`([^`]+)`/g, '$1')
    .replace(/\*([^*]+)\*/g, '$1')
    .replace(/_([^_]+)_/g, '$1')
    .replace(/<([^|>]+)\|([^>]+)>/g, '$2')
    .replace(/<([^>]+)>/g, '$1')
    .replace(/^• /gm, '')
    .replace(/\s+/g, ' ')
    .trim();
}

export function removeMarkdownImage(
  value: string,
  attachment: MarkdownImageAttachment,
): string {
  const candidates = attachmentUrls(attachment);
  if (candidates.length === 0) {
    return value;
  }

  IMAGE_TOKEN_RE.lastIndex = 0;
  let match: RegExpExecArray | null = IMAGE_TOKEN_RE.exec(value);
  while (match) {
    const tokenDest = match[1];
    const matchesAttachment = destUrls(tokenDest).some((destUrl) =>
      candidates.some((candidate) => urlsMatch(destUrl, candidate)),
    );
    if (matchesAttachment) {
      const next = `${value.slice(0, match.index)}${value.slice(
        match.index + match[0].length,
      )}`;
      IMAGE_TOKEN_RE.lastIndex = 0;
      return next.replace(/\n{3,}/g, '\n\n').trim();
    }
    match = IMAGE_TOKEN_RE.exec(value);
  }

  IMAGE_TOKEN_RE.lastIndex = 0;
  return value;
}
